<template>
  <modal :modal-title="'Continue?'"
         :icon="'fa-clock'"
         :small-modal="true"
         :modal-id="'extend-timer-modal'">
    <template slot>
      <p>
        Your placement will expire in
        <span class="tdesk-failure">{{timer.minutes}}:{{timer.seconds}}</span>
      </p>
      <notice :message="'This is the final time you can renew your placement.'"
              :importance="'primary'"
              :icon="'fa-exclamation-triangle'"
              :type="'warning'"></notice>
      <a href="#" class="tdesk-primary-button" @click="restartTimer()">
        <i class="fas fa-check-circle"></i>
        Continue
      </a>
      <div @click="cancelBooking()" class="tdesk-tertiary-button">
        <i class="fas fa-times"></i>
        Cancel order
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '../../modal';
  import Notice from '../../tdesk_notice';

  export default {
    props: {
      timer: {
        required: true,
        type: Object
      }
    },
    components: {Modal, Notice},
    mounted() {
      $('#extend-timer-modal').modal('show');
    },
    methods: {
      cancelBooking() {
        this.hideModal();
        this.$emit('cancel-booking');
      },
      hideModal() {
        $('#extend-timer-modal').modal('hide');
      },
      restartTimer() {
        this.hideModal();
        this.$emit('restart-timer');
      }
    }
  }
</script>